<template>
  <div class="rule_box">
    <div>
      <Row
        :gutter="8"
        style="margin: 0px 0 0 0; width: 100%"
        v-if="menus && menus.length > 0"
      >
        <Menu
          mode="horizontal"
          :active-name="menu_name"
          @on-select="selectMenu"
          style="width: 100%"
        >
          <div
            v-for="(v, k) in menus"
            :key="k"
            style="display: inline-block"
            v-auth="v.auth"
          >
            <MenuItem
              :name="v.name"
              @click="v.onClick"
              v-show="v.show === true ? false : true"
            >
              <Badge
                :overflow-count="10000000"
                v-if="v.badge && v.badge.count"
                :count="v.badge.count"
                :offset="[18, -3]"
              >
                {{ v.label }}
              </Badge>
              <span v-if="!(v.badge && v.badge.count)">
                {{ v.label }}
              </span>
            </MenuItem>
          </div>
        </Menu>
      </Row>
    </div>
    <div style="margin: 15px 0">
      <Button size="default" type="info" icon="md-add" @click="toAdd()"
        >新增
      </Button>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%; margin-bottom: 20px"
      row-key="menuId"
      border
      :default-expand-all="false"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="menuName" label="规则名称" width="180">
      </el-table-column>
      <el-table-column prop="orderNum" width="80" align="center" label="排序">
      </el-table-column>
      <el-table-column prop="component" label="菜单路径"> </el-table-column>
      <el-table-column prop="menuType" label="权限类型">
        <template slot-scope="scope">
          <div>
            {{
              scope.row.menuType == "M"
                ? "目录"
                : scope.row.menuType == "C"
                ? "菜单"
                : scope.row.menuType == "F"
                ? "按钮"
                : ""
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="菜单状态">
        <template slot-scope="scope">
          <div
            :style="{
              color:
                scope.row.status == 0
                  ? 'blue'
                  : scope.row.status == 1
                  ? 'red'
                  : '',
            }"
          >
            {{
              scope.row.status == 0
                ? "正常"
                : scope.row.status == 1
                ? "停用"
                : ""
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <div
            style="display: flex; justify-content: center; align-items: center"
          >
            <div
              style="
                margin-right: 10px;
                color: rgb(73, 145, 255);
                cursor: pointer;
              "
              @click="handleEdit(scope.row)"
            >
              编辑
            </div>
            <div
              style="color: rgb(73, 145, 255); cursor: pointer"
              @click="handleDel(scope.row)"
            >
              删除
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
// import baseList from '@/views/components/base/baseList.vue'
import { Tag, Button } from "view-design";
import Vue from "vue";
export default {
  // extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "menu2",
        key: "menuId",
        url: {
          del: "/admin/system/menu",
        },
        output: false,
      },
      menu_name: "",
      tableData: [],
      // actions: [
      //   {
      //     label: '新增',
      //     icon: 'md-add',
      //     onClick: this.toAdd,
      //     type: "info",
      //     auth: 'admin/authrule/add',
      //   },
      // ],
      menus: [
        {
          label: "后台权限",
          name: "auth_rule_list",
          auth: "",
        },
        {
          label: "用户权限",
          name: "weapp_client_list",
          auth: "",
        },
        {
          label: "维修权限",
          name: "weapp_engineer_list",
          auth: "",
        },
        // { label: '用户权限', name: 'auth_access_list', auth: '/admin/authaccess/lists' },
        // { label: '角色权限', name: 'auth_group_list', auth: '/admin/authgroup/lists' },
        // { label: '权限规则', name: 'auth_rule_list', auth: '/admin/authrule/lists' },
      ],
      filters: [],
      // tableCols: [
      //   {
      //     title: '序号',
      //     type: 'index',
      //     width: 80,
      //     align: 'center',
      //   },
      //   {
      //     title: '规则名称',
      //     key: 'menuName',
      //     minWidth: 160,
      //     align: 'center',
      //   },
      //   // {
      //   //   title: '路由',
      //   //   key: 'path',
      //   //   minWidth: 120,
      //   //   align: 'center',
      //   // },
      //   {
      //     title: '菜单路径',
      //     minWidth: 160,
      //     align: 'center',
      //     key: 'component',
      //   },
      //   {
      //     title: '按钮路径',
      //     key: 'perms',
      //     minWidth: 120,
      //     align: 'center',
      //   },
      //   {
      //     title: '权限类型',
      //     align: 'center',
      //     key: 'menuType',
      //     minWidth: 120,
      //     render: (h, params) => {
      //       const row = params.row
      //       const text = row.menuType == "M" ? '目录' : row.menuType == "C" ? '菜单' : row.menuType == "F" ? '按钮' : ''
      //       return h(
      //         'span',
      //         {
      //           style: {
      //             'font-size': '14px',
      //           },
      //         },
      //         text
      //       )
      //     },
      //   },
      //   {
      //     title: '菜单状态',
      //     align: 'center',
      //     key: 'status',
      //     minWidth: 120,
      //     render: (h, params) => {
      //       const row = params.row
      //       const color = row.status == 0 ? 'blue' : row.status == 1 ? 'red' : ''
      //       const text = row.status == 0 ? '正常' : row.status == 1 ? '停用' : ''
      //       return h(
      //         'span',
      //         {
      //           style: {
      //             'font-size': '14px',
      //             color: color,
      //           },
      //         },
      //         text
      //       )
      //     },
      //   },
      //   {
      //     title: '操作',
      //     align: 'center',
      //     minWidth: 190,
      //     key: 'handle',
      //     handle: ['edit', 'delete'],
      //     auth: {
      //       edit: 'admin/authrule/edit',
      //       del: 'admin/authrule/delete',
      //     }
      //   },
      // ],
    };
  },
  created() {
    let route = this.$route;
    if (route) {
      this.menu_name = route.name;
    }
    this.load();
  },
  methods: {
    selectMenu(name) {
      if (this.menu_name !== name) {
        setTimeout(() => {
          this.$destroy();
        }, 100);
        $utils.url.push({ name: name, params: { refresh: true } });
      }
    },
    toAdd() {
      $utils.url.push({ name: "auth_rule_add", query: { action: "add" } });
    },
    handleEdit(row) {
      $utils.url.push({
        name: "auth_rule_edit",
        query: { action: "edit", kv: row.menuId },
      });
    },
    handleDel(row) {
      let q = {};
      q.kv = row.menuId;
      console.log(row);
      $utils.api
        .load("/admin/system/menu" + "/" + row.menuId, q, "DELETE")
        .then((res) => {
          if (res && res.status) {
            this.load();
            $utils.toast.text(res.msg);
          }
        });
    },
    async load() {
      let q = {};
      let res = await $utils.api.load("/admin/system/menu/m/list", q, "get");
      console.log(res);
      if (res.code == 200) {
        this.tableData = res.rows;
      }
    },
  },
};
</script>
<style scoped></style>
